import { utilBuildings } from "../../../utils/utilBuildings";
import { selectAcresAvailable } from "../selectors/selectAcresAvailable";
export var checkAnyAcreNotConstructingAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var acresAvailable = selectAcresAvailable(state);
    var hasAnyAcresFinishedProduction = acresAvailable.some(utilBuildings.isIdle);
    return hasAnyAcresFinishedProduction ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyAcreNotConstructingAvailable.ts
// module id = 2391
// module chunks = 3